<template>
	<v-dialog
		v-model="dialog"
		max-width="1200"
		:fullscreen="$vuetify.breakpoint.smAndDown ? true : false"
		:transition="$vuetify.breakpoint.smAndDown ? 'scroll-y-reverse-transition' : ''"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn
				:text="text"
				:color="text ? 'white' : 's econdary'"
				class="ml-2"
				v-bind="attrs"
				v-on="on"
			>
				<v-icon class="mr-1">mdi-plus</v-icon>
				作業者を追加
			</v-btn>
		</template>

		<v-card :tile="$vuetify.breakpoint.smAndDown">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white" class="color-white"> 作業者を追加 </v-toolbar-title>
				<v-spacer />
				<v-btn icon dark @click="dialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<div class="pa-2">
				<ValidationError :errors="errors" />
				<v-form ref="form" v-model="valid">
					<ConstructionWorkerForm
						:worker_data.sync="worker"
						:existing_files.sync="existing_files"
						:files_data.sync="files"
						:qualifications="qualifications"
					/>
				</v-form>
				<v-row no-gutters class="mt-4">
					<v-col sm="3" cols="0" />
					<v-col sm="6" cols="12" class="text-center">
						<v-btn color="secondary" :disabled="!valid" @click="submitForm">
							<v-icon class="mr-1">mdi-plus</v-icon>
							保存する
						</v-btn>
					</v-col>
					<v-col sm="3" cols="0" class="text-right">
						<v-btn text @click="closeDialog"> キャンセル </v-btn>
					</v-col>
				</v-row>
			</div>
		</v-card>
	</v-dialog>
</template>
<script>
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import common from "../../../helper/common"
import ValidationError from "../../shared/ValidationError.vue"
import ConstructionWorkerForm from "./ConstructionWorkerForm.vue"

export default {
	props: {
		text: {
			type: Boolean,
			default: false,
		},
		qualifications: {
			type: Array,
			default: () => {
				return []
			},
		},
	},
	components: {
		ValidationError,
		ConstructionWorkerForm,
	},
	data() {
		return {
			worker: {
				todo: null,
				worker_qualifications_attributes: [
					{
						name: null,
					},
				],
			},
			existing_files: [],
			files: [],
			dialog: false,
			valid: false,
			common,
			errors: [],
		}
	},
	methods: {
		submitForm() {
			// TODO filesも追加
			const headers = authenticate.setHeader()
			const url = `/erp/v1/constructions/workers`
			const params = { worker: this.worker }
			axios
				.post(url, params, { headers })
				.then((res) => {
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "作業者を追加しました",
					})
					this.$emit("create-worker")
				})
				.catch((err) => {
					const errors = errorHandling.errorResponse(err)
					if (Array.isArray(errors)) {
						this.errors = errors
					}
				})
		},
		closeDialog() {
			this.dialog = false
			this.$refs.form.reset()
		},
	},
}
</script>
